/**
 * video module.
 * @module video
 */

import Core from '../modules/core/';
import Control from '../modules/recodeControl/';
import Title from '../modules/title/';
import List from '../modules/list/';
import Recommend from '../modules/recommend/';
import ErrorBox from '../modules/error';
import Stat from 'f.component.video.vStat';
import version from 'version';

// const vStat = new Stat(videoinfo);
import Events from 'f.core.event';
import Util from 'f.core.util.pc';
const pcVideoUtil = new Util();
import antiTheft from 'f.component.video.auth';

/**
 * Video 业务核心
 */
class Video {
    /**
     * Creates an instance of Video.
     * @param {Object} obj - An object.
     * @param {Object} obj.videoinfo - 视频相关信息.
     * @param {Object} obj.playermsg - 视频地址.
     * @param {Object} obj.recommend - 后推荐数据.
     * @param {Object} obj.sedata - 相关列表数据.
     * @memberof Video
     */
    constructor({ videoinfo, playermsg, recommend, sedata, isAuth }) {
        /**
         * videoInfo
         *
         * @member {object}
         */
        this.videoinfo = videoinfo;

        /**
         * playermsg
         *
         * @member {object}
         */
        this.playermsg = playermsg;

        /**
         * 后推荐信息
         *
         * @member {object}
         */
        this.recommends = recommend;

        /**
         * 相关列表数据
         *
         * @member {object}
         */
        this.sedata = sedata;

        /**
         * 是否使用防盗链
         *
         * @member {object}
         */
        this.isAuth = isAuth || 'auth';

        /**
         * 统计类
         *
         * @member {object}
         */
        this.vStat = new Stat(videoinfo);

        /**
         * 是否为第一次播放 2.0 canplay
         *
         * @member {Boolean}
         */
        this.first_play = true;

        /**
         * 是否为第一次loadstart 2.0 loadstart
         *
         * @member {Boolean}
         */
        this.loadstartfirst = true;

        /**
         * 是否为第一次loadeddatafirst 2.0 loadeddata
         *
         * @member {Boolean}
         */
        this.loadeddatafirst = true;

        /**
         * 上一次时间，为了监测卡顿
         *
         * @member {number}
         */
        this.lastMonitor = 0;

        /**
         * 监测卡顿标志
         *
         * @member {number}
         */
        this.monitorFlag = 1;

        /**
         * 卡顿持续时间
         *
         * @member {number}
         */
        this.stopContinue = 0;

        /**
         * 卡顿次数
         *
         * @member {number}
         */
        this.stopTimes = 0;

        /**
         * 卡顿定时器
         *
         * @member {number}
         */
        this.monitorTimer = null;

        this.volumeValueTimer = null; // 音量提示框消失计时器

        /**
         * 文本提示框消失计时器
         *
         * @member {number}
         */
        this.VideoTextConTimer = null;

        /**
         * app推广定时器
         *
         * @member {number}
         */
        this.appTimer = null;

        /**
         * 是否全屏
         *
         * @member {Boolean}
         */
        this.isfull = false;

        /**
         * 第一次下载结束
         *
         * @member {Boolean}
         */
        this.end = true;

        /**
         * 点击播放 定时器
         *
         * @member {number}
         */
        this.conClickTimer == null;

        /**
         * 当前播放的时间
         *
         * @member {number}
         */
        this.currentTime = 0;

        /**
         * seek 次数
         */
        this.seekTime = 0;

        this.init();
    }

    /**
     * 初始化
     *
     */
    init() {
        /**
         * 发送vv统计
         */
        this.vStat.sendMedia('vv');

        /**
         * 采样标识统计
         */
        this.vStat.sendVplayer('100000');

        this.initLayout();
        this.initCompontent();
        this.initEvent();
    }

    /**
     * 初始化布局
     *
     */
    initLayout() {
        // this.el = document.createElement('div');
        // this.el.classList.add('c-video');
        // 播放器整体
        this.container = document.getElementById('playercontainer');
        this.videobox = document.getElementsByClassName('videobox')[0];
        this.player = document.getElementById('js_video_container');
    }

    /**
     * 初始化布局
     *
     */
    initCompontent() {
        // 请求视频播放地址
        let _params = {
            container: this.container,
            sedata: this.sedata,
            videoinfo: this.videoinfo,
            recommend: this.recommends,
        };

        let playermsg = this.playermsg;

        let src = playermsg.gqSrc || playermsg.bqSrc;
        this.mp4Data = playermsg;
        this.updateSrcVideoUrl(src);

        // video
        this.core = new Core({
            src,
            poster: playermsg.videoLargePoster,
        });

        // this.core = Promise.resolve(this.__core);

        this.control = new Control(_params);

        this.title = new Title({ title: this.videoinfo.name });

        this.list = new List(_params);

        this.recommend = new Recommend(_params);

        this.error = new ErrorBox();

        this.core.renderTo(this.player); // 将播放器放置到播放器的容器中

        // this.playButton.renderTo(this.el);
        this.control.renderTo(this.videobox);
        // this.recommend.renderTo(this.container);
        this.error.renderTo(this.container);

        this.title.renderTo(this.container);
        // this.list.renderTo(this.container);
    }

    /**
     * 渲染dom
     *
     * @param {HTMLELEMENT} parentNode
     * @memberof Video
     */
    renderTo(parentNode) {
        parentNode.appendChild(this.el);
    }

    /**
     * 自定义事件列表
     * begin 每个视频开始播放时 一般用来发cv统计
     * ended 视频播放结束时
     * pause 视频暂停
     * play 视频播放
     * switch 视频切换
     * init 初始化视频 主要用于发vv统计
     */
    initEvent() {
        let core = this.core;
        let control = this.control;
        // let recommend = this.recommend;
        let title = this.title;
        // let list = this.list;
        let error = this.error;
        let self = this;
        let initvolume = pcVideoUtil.playerGetCookie('videoVolume') || 0.5;

        core.on('timeupdate', e => {
            // console.log(self.first)
            let currentTime = core.getCurrentTime();
            let bufferedTime = core.getBuffered();
            let duration = core.getDuration();

            if (isNaN(duration)) {
                duration = 0;
            }

            /** 视频资源下载完成 */
            if (self.end == true && bufferedTime == duration && duration != 0) {
                self.vStat.sendVplayer(307000);
                self.end = false;
            }

            control.setCurrentTime(currentTime);
            control.setTotalTime(duration);

            /** 更新进度条 */
            if (duration != 0) {
                control.setCurrentProgress(currentTime / duration);
                control.setBufferProgress(bufferedTime / duration);
            }

            self.trigger('timeupdate', currentTime);
            self.currentTime = currentTime;
        });

        core.on('play', () => {
            control.changePlayBtnState('play');
            self.trigger('play');
        });

        core.on('loadstart', function() {
            // 发送统计
            // console.log('loadstart');
            /** 开始加载 */
            if (self.loadstartfirst == true) {
                self.vStat.sendVplayer(208000);
                self.loadstartfirst = false;
            }
            let time = 0;
            // 超过10秒报error
            self.timerhehe = setInterval(() => {
                time++;
                // console.log(time);
                if (time >= 10) {
                    self.trigger('error', '9', core.el.currentTime);
                    clearInterval(self.timerhehe);
                }
            }, 1000);
        });

        /** 获取资源长度 */
        core.on('loadedmetadata', () => {
            // console.log('loadedmetadata');
            core.setVolume(initvolume);
            control.setCurrentVolume(initvolume);
            control.setVolumeWarn(initvolume);

            self.trigger('init');
        });

        core.on('loadeddata', function() {
            /**
             * loadeddata时取消10秒超时定时器
             */
            clearInterval(self.timerhehe);

            /**
             * 首字节响应发送统计
             */
            if (self.loadeddatafirst == true) {
                self.vStat.sendVplayer('302000');
                self.loadeddatafirst = false;
            }
        });

        core.on('canplay', () => {
            // console.log('canplay')
            /**
             * 首画面呈现，发送统计
             */
            if (self.first_play == true) {
                // self.showAppPopularize();

                // 发送首画面呈现统计
                self.vStat.sendVplayer('303000');
                // 发送cv统计
                self.vStat.sendMedia('cv'); // 正片

                self.trigger('firstPlay');
                self.first_play = false;
            }
            // core.el.play();
            self.trigger('canplay');
        });

        // 视频暂停
        core.on('pause', () => {
            control.changePlayBtnState('pause');
        });

        /**
         * 视频播放完成
         */
        core.on('ended', () => {
            self.ended(core, self, control);
        });

        core.on('error', function(e) {
            console.log('error', core.el.error, 'code', core.el.error.code);

            clearInterval(self.timerhehe);
            self.trigger('error', core.el.error.code, core.el.currentTime);
        });

        /**
         * 控制条播放
         */
        control.on('cplay', () => {
            /** 视频播放时发送统计 */
            self.vStat.sendVplayer('401000');
            self.play();
        });

        /**
         * 控制条暂停
         */
        control.on('cpause', () => {
            /** 视频暂停时发送统计 */
            self.vStat.sendVplayer('402000');
            self.pause();
        });

        /**
         * 静音
         */
        control.on('cmute', () => {
            core.setVolume(0.0);
            control.setCurrentVolume(0);
            control.setVolumeWarn(0);
            /** 视频静音时发送统计 */
            self.vStat.sendVplayer('405000');
        });

        /**
         * 取消静音
         */
        control.on('caloud', () => {
            let initVolume = pcVideoUtil.playerGetCookie('videoVolume');
            core.setVolume(initVolume);
            control.setCurrentVolume(initVolume);
            control.setVolumeWarn(initVolume);
        });

        /**
         * 控制条——进度seek
         */
        control.on('cprogress', percent => {
            let duration = core.getDuration();
            if (isNaN(duration)) {
                return;
            }
            if (duration != 0) {
                control.setCurrentProgress(percent);
            }
            // console.log(percent)
            core.setCurrentTime(duration * percent);

            /** 视频seek统计，第一次发403001 */
            self.vStat.sendVplayer(`403${pcVideoUtil.formatNum(++self.seekTime)}`);
        });

        control.on('cpdown', () => {});

        /**
         * 控制条——进度条读管——移动
         */
        control.on('cpmove', percent => {
            let duration = core.getDuration();
            if (isNaN(duration)) {
                return;
            }
            // console.log(percent)
            control.setCurrentProgress(percent);

            core.setCurrentTime(duration * percent);
        });

        const yinliang = percent => {
            let _class = '';
            // 音量改变设置cookie
            pcVideoUtil.playerSetCookie('videoVolume', percent, {
                domain: '.ifeng.com',
                path: '/',
                expires: 60 * 24 * 360,
            });
            // console.log(percent)
            control.setCurrentVolume(percent);
            control.setVolumeWarn(percent);
            core.setVolume(percent);
            control.volumeTipShow();

            if (percent >= 0 && percent <= 0.3) {
                _class = 'little';
            } else if (percent > 0.3 && percent <= 0.6) {
                _class = 'middle';
            } else {
                _class = 'large';
            }

            pcVideoUtil.removeClass(control.mute, 'little');
            pcVideoUtil.removeClass(control.mute, 'middle');
            pcVideoUtil.removeClass(control.mute, 'large');

            if (percent == 0) {
                $(control.aloud).show();
                $(control.mute).hide();
            } else {
                $(control.aloud).hide();
                $(control.mute).show();
            }

            pcVideoUtil.addClass(control.mute, _class);

            let sendCode = Math.round(percent * 100);

            /** 音量调节统计 例： 80发送080 */
            self.vStat.sendVplayer(`406${pcVideoUtil.formatNum(sendCode)}`);
        };

        /**
         * 控制条进度seek
         */
        control.on('c_v_progress', yinliang);

        /**
         * 控制条移动
         */
        control.on('cvmove', yinliang);

        /**
         * 控制条——进度条时间显示——移动
         */
        control.on('cpseekmove', function(percent) {
            let duration = core.getDuration();

            control.seekTimeShow(); // 显示
            let elW = $(this.el).width();
            // let elL = $(this.el).offset().left;

            let seekW = $(this.seekTimeAll).width();
            // let seekL = $(this.seekTimeAll).offset().left;

            let bi = seekW / 2 / elW;
            let oo = null;
            if (percent > bi && percent < 1 - bi) {
                oo = percent - seekW / (2 * elW);
            } else if (percent < bi) {
                oo = 0;
            } else if (percent > 1 - bi) {
                oo = 1 - bi - seekW / (2 * elW);
            }

            control.setSeekProgress(oo);
            control.setSeekTime(duration * percent);

            if (self.mp4Data.preview.path && percent) {
                control.showImgPreview(duration * percent, self.mp4Data.preview);
            }
        });

        /**
         * 控制条——进度条时间显示——隐藏
         */
        control.on('cpseekout', () => {
            control.seekTimeHide();
        });

        /**
         * 修改video视频清晰度 - 高清、标清
         */
        control.on('changeVideoRate', function(ele) {
            if (!self.mp4Data.gqSrc || !self.mp4Data.bqSrc) return;

            let time = core.getCurrentTime();
            // console.log(time)
            self.VideoTextConTimer = null;
            let __gid = window.gid;
            let tag = ele.getAttribute('data-tag');
            let src =
                tag == 'high' ? self.mp4Data.gqSrc : tag == 'middle' ? self.mp4Data.bqSrc : self.mp4Data.gqSrc;
            src = self.isAuth == 'auth' ? `${src}?${antiTheft({ videoinfo, __gid, version })}` : src;
            let textstr = tag == 'high' ? '高清' : tag == 'middle' ? '标清' : '高清';
            $(ele)
                .addClass('current')
                .siblings()
                .removeClass();
            $('.video_app_QRCode').hide();
            control.videoTextShow();
            control.setVideoTextCon(`正在切换到“${textstr}”`);
            core.el.src = src;
            self.updateSrcVideoUrl(src);
            core.setCurrentTime(time);
            core.play();
            control.setVideoTextCon(`已经切换到“${textstr}”`);
            control.setVideoRateTxt(textstr);

            /** 提示消失 */
            self.VideoTextConTimer = setTimeout(() => {
                control.videoTextHide();
            }, 800);

            let sendCode = tag == 'high' ? 1 : 0;

            /** 视频清晰度统计 */
            self.vStat.sendVplayer(`11200${sendCode}`);
        });

        /**
         * 全屏
         */
        control.on('full', () => {
            control.launchFullscreen(self.container);
            self.fullChange(self.container, 'full');
            title.show();

            self.showTimer = setInterval(() => {
                title.showTime();
            }, 1000);

            /**
             * 全屏切换统计
             */
            self.vStat.sendVplayer('404000');
        });

        /**
         * 退出全屏
         */
        control.on('exit', () => {
            control.exitFullscreen(self.container);
            self.fullChange(self.container, 'exit');
            title.hide();

            self.showTimer = null;

            /**
             * 全屏切换统计
             */
            self.vStat.sendVplayer('404000');
        });

        /**
         * esc快捷键 退出
         */
        pcVideoUtil.bind(
            document,
            ['webkitfullscreenchange', 'fullscreenchange', 'mozfullscreenchange', 'msfullscreenchange'],
            ev => {
                // 监听全屏、退出全屏切换 为了监测esc触发退出全屏
                if (self.isfull) {
                    self.fullChange(self.container, 'exit');
                    title.hide();
                    self.list.initShow();
                    self.list.hide();
                    control.changeFull('exit');
                    self.showTimer = null;
                }

                if (self.isfull) {
                    self.isfull = false;
                } else {
                    self.isfull = true;
                }
            },
        );

        title.on('close', () => {
            self.trigger('qpClose');
        });

        title.on('open', () => {
            self.trigger('qpOpen');
        });

        /**
         * 全屏时，改变视频尺寸
         */
        title.on('changeVideoSize', ele => {
            let _type = ele.getAttribute('data-tag');
            let sendCode = _type == 'half' ? '1' : _type == 'all' ? '2' : '3';
            core.el.style.width = _type == 'half' ? '50%' : '100%';
            core.el.style.height = _type == 'half' ? '50%' : _type == 'all' ? '100%' : 'auto';
            $(ele)
                .addClass('current')
                .siblings()
                .removeClass();
            /**
             * 发送全屏时画面尺寸统计
             */
            self.vStat.sendVplayer(`40400${sendCode}`);
        });

        /**
         * 换节目
         */
        title.on('listshow', type => {
            self.list.initShow();
            self.list[type]
                .addClass('current')
                .siblings()
                .removeClass('current');
            // 发送统计
            let sendCode = null;

            /**
             * 发送点击视频列表按钮统计
             */
            if (type == 'list') {
                sendCode = '502000';
                self.vStat.sendVplayer(sendCode);
            } else if (type == 'share') {
                /**
                 * 发送点击分享按钮统计
                 */
                sendCode = '503000';
                self.vStat.sendVplayer(sendCode);
            }
        });

        /**
         * 分享统计
         */
        self.list.on('sendVplayer', _sendcode => {
            // console.log(_sendcode)
            self.vStat.sendVplayer(_sendcode);
        });

        /**
         * 错误提示界面，重播按钮
         */
        error.on('replay', () => {
            error.hide();
            self.recommend.initShow();
            self.recommend.hide();
            self.trigger('replay');
            self.src(self.srcVideoUrl);
            core.load();
            self.show();
            self.play();
        });

        /**
         * 检测卡顿
         */
        self.monitorTimer = setInterval(() => {
            self.kadun(core);
        }, 1000);

        /**
         * 鼠标悬浮在播放器上方
         */
        $('#player').on('mousemove', e => {
            control.show();
            if (self.isfull) {
                title.show();
            }
            clearTimeout(control.hideTimer);
            control.hideTimer = null;
            if (!control.hideTimer && control.playBtnstatus == 'play') {
                control.hideTimer = setTimeout(() => {
                    control.hide();
                    title.hide();
                }, 2000);
            }
        });

        /**
         * 点击player区域，添加键盘快捷键
         */
        $('#playercontainer').on('click', e => {
            // e.stopPropagation();

            $(document).bind('keydown', e => {
                self.processChange(e);
            });
            // return false;
            // $(box).unbind('mousedown');
        });

        /**
         * 解绑键盘快捷键
         */
        $(document).bind('mousedown', e => {
            $(document).unbind('keydown');
        });

        /**
         * 视频点击播放暂停
         */
        $('#player').on('click', e => {
            clearTimeout(self.conClickTimer);
            self.conClickTimer = setTimeout(() => {
                if (core.__isPlayed) {
                    /**
                     * 视频播放统计
                     */
                    self.vStat.sendVplayer('402000');
                    self.pause();
                } else {
                    /**
                     * 视频暂停统计
                     */
                    self.vStat.sendVplayer('401000');
                    self.play();
                }
            }, 300);
        });

        /**
         * 双击全屏，退出全屏
         */
        $('#player').on('dblclick', e => {
            clearTimeout(self.conClickTimer);

            if (control.fullStatus == 'exit' && !self.isfull) {
                control.launchFullscreen(self.container);
                control.changeFull('full');
                self.fullChange(self.container, 'full');
                title.show();

                self.showTimer = setInterval(() => {
                    title.showTime();
                }, 1000);
                /**
                 * 发送全屏切换统计
                 */
                self.vStat.sendVplayer('404000');
            } else if (control.fullStatus == 'full' && self.isfull) {
                control.exitFullscreen(self.container);
                control.changeFull('exit');
                self.fullChange(self.container, 'exit');
                title.hide();

                self.showTimer = null;
                /**
                 * 发送全屏切换统计
                 */
                self.vStat.sendVplayer('404000');
            }
        });
    }

    /**
     * 缓存视频源地址
     *
     * @param {string} url
     */
    updateSrcVideoUrl(url) {
        this.srcVideoUrl = url;
        window.srcVideoUrl = url;
    }

    /**
     * 设置播放视频源地址
     *
     * @param {string} url
     */
    src(url) {
        let core = this.core;
        core.el.src = url;
    }

    /**
     * 执行keydown的方法
     *
     * @param {object} e
     */
    processChange(e) {
        /**
         * 空格:32
         * 左:37
         * 上:38
         * 右:39
         * 下:40
         */
        if (!e) return;
        const _code = e.keyCode;
        const playBtnstatus = this.control.playBtnstatus;
        switch (_code) {
            /**
             * 播放、暂停
             */
            case 32:
                if (playBtnstatus == 'pause') {
                    this.vStat.sendVplayer('401000');
                    this.play();
                } else {
                    this.vStat.sendVplayer('402000');
                    this.pause();
                }
                e.preventDefault();

                break;

            /**
             * 快退
             */
            case 37:
                this.changeVideoFucntion('-');
                e.preventDefault();

                break;

            /**
             * 声音加大
             */
            case 38:
                this.changeVolumeFucntion('+');
                e.preventDefault();

                break;

            /**
             * 快进
             */
            case 39:
                this.changeVideoFucntion('+');
                e.preventDefault();

                break;

            /**
             * 声音减小
             */
            case 40:
                this.changeVolumeFucntion('-');
                e.preventDefault();

                break;

            default:
                break;
        }
    }

    /**
     * 全屏、退出全屏时的样式变化
     *
     * @param {HTMLELEMENT} ele
     * @param {string} type 状态
     */
    fullChange(ele, type) {
        /**
         * 全屏时样式
         */
        if (type == 'full') {
            pcVideoUtil.addClass(ele, 'boxFullScreen');
        } else {
            /**
             * 退出全屏时样式
             */
            pcVideoUtil.removeClass(ele, 'boxFullScreen');
        }
        this.trigger('fullChange');
    }

    /**
     * 视频快退快进
     *
     * @param {string} tag 进退方向
     */
    changeVideoFucntion(tag) {
        let core = this.core;
        let duration = core.getDuration();
        let currentTime = null;
        if (isNaN(duration)) {
            duration = 0;
        }
        if (tag == '+') {
            currentTime = core.getCurrentTime() + 8;
            if (currentTime > duration) {
                currentTime = duration;
            }
        } else {
            currentTime = core.getCurrentTime() - 8;
            if (currentTime < 0) {
                currentTime = 0;
            }
        }
        core.setCurrentTime(currentTime);
        this.control.setCurrentTime(currentTime);
        this.control.setTotalTime(duration);
        if (duration != 0) {
            this.control.setCurrentProgress(currentTime / duration);
        }
    }

    /**
     * 音量增加减少
     *
     * @param {string} tag 增加减少方向
     */
    changeVolumeFucntion(tag) {
        let core = this.core;
        let volume = core.getVolume();
        if (tag == '+') {
            volume += 0.1;
            if (volume > 1) {
                volume = 1;
            }
            $(this.control.aloud).hide();
            $(this.control.mute).show();
        } else {
            volume -= 0.1;
            if (volume < 0) {
                volume = 0;
                $(this.control.aloud).show();
                $(this.control.mute).hide();
            }
        }

        pcVideoUtil.playerSetCookie('videoVolume', volume, {
            domain: '.ifeng.com',
            path: '/',
            expires: 60 * 24 * 360,
        });
        this.control.setCurrentVolume(volume);
        this.control.setVolumeWarn(volume);
        core.setVolume(volume);

        this.control.volumeTipShow();

        let _class = volume >= 0 && volume <= 0.3 ? 'little' : volume > 0.3 && volume <= 0.6 ? 'middle' : 'large';
        pcVideoUtil.removeClass(this.control.mute, 'little');
        pcVideoUtil.removeClass(this.control.mute, 'middle');
        pcVideoUtil.removeClass(this.control.mute, 'large');
        // if (percent == 0) {
        //     $(control.aloud).show();
        //     $(control.mute).hide();
        // } else {
        //     $(control.aloud).hide();
        //     $(control.mute).show();
        // }
        pcVideoUtil.addClass(this.control.mute, _class);
    }

    /**
     * 视频左下角 App 流行推广
     *
     * @memberof Video
     */
    showAppPopularize() {
        // body...
        let _this = this;
        let playtimes = pcVideoUtil.playerGetCookie('playtimes') || 1;
        pcVideoUtil.playerSetCookie('playtimes', ++playtimes, {
            domain: '.ifeng.com',
            path: '/',
            expires: 60 * 24 * 360,
        });
        if (playtimes % 3 == 0) {
            $.ajax({
                url: 'http://v.ifeng.com/flash/data/app/tuig.js',
                type: 'get',
                dataType: 'json',
                success(data) {
                    // var data = { "text": "[APP专享]野外发现红包袱 打开一看众人惊呆", "link": "http://v.ifeng.com/apps/index.shtml#_a_v1", "img": "http://p0.ifengimg.com/a/2016_23/6fb82450ea5e4c5_size14_w110_h110.jpg" };
                    document.getElementById('js_video_text').innerHTML = `${data.text}<a id="js_show_code" href="javascript:void(0)">下载客户端观看</a>`;

                    // _this.videoTextCon.html(data.text + '<a id="js_show_code" href="javascript:void(0)">下载客户端观看</a>');
                    pcVideoUtil.bind(document.getElementById('js_show_code'), 'click', function(e) {
                        clearTimeout(_this.appTimer);
                        this.appTimer = null;
                        // _this.videoPlay('pause', 'appClick');
                        pcVideoUtil.addClass(
                            document.getElementsByClassName('video_app_QRCode')[0],
                            'video_app_QRCodeShow',
                        );
                    });

                    let appImgDom = document.createElement('img');
                    appImgDom.src = data.img;
                    document.getElementsByClassName('video_app_QRCode')[0].appendChild(appImgDom);

                    // pcVideoUtil.addClass(_this._textshow, 'videoTextShow');
                    _this.control.videoTextShow();
                    _this.appFlag = 1;
                    _this.appTimer = setTimeout(() => {
                        _this.control.videoTextHide();
                        $('.video_app_QRCode').hide();
                        // textBoxHide('click');
                    }, 30000);
                },
                error(e) {
                    console.log(e)
                }
            });
        }
    }

    /**
     * 卡顿测试函数
     *
     * @param {object} core
     */
    kadun(core) {
        // body...
        let _this = this;
        let tag = core.getPaused();

        if (tag) return;
        if (core.getCurrentTime() == 0) return;

        // console.log(tag)
        // console.log('lastMonitor:' + this.lastMonitor);
        // console.log(core.getCurrentTime());

        if (this.lastMonitor == core.getCurrentTime()) {
            if (this.monitorFlag) {
                _this.vStat.sendVplayer(`304${pcVideoUtil.formatNum(++this.stopTimes)}`); //缓冲次数
                // console.log('卡顿次数：' + pcVideoUtil.formatNum(this.stopTimes));
            }
            this.monitorFlag = 0;
            this.stopContinue++;
            console.log(`this.stopContinue=====>`, this.stopContinue);
            if (this.stopContinue > 5) {
                // 卡顿时间超过5s，认为播放失败，显示后推荐
                this.stopContinue = 0;
                clearInterval(_this.monitorTimer);
                _this.monitorTimer = null;
                // videorecommendShow('error');显示后推荐
            }
        } else {
            this.monitorFlag = 1;
            if (this.stopContinue != 0) {
                // console.log('卡顿持续时间：' + pcVideoUtil.formatNum(this.stopContinue));
                _this.vStat.sendVplayer(
                    `309${pcVideoUtil.formatNum(this.stopTimes)}${pcVideoUtil.formatNum(this.stopContinue)}`,
                ); // 309xxxyyy x：卡的次数 y：卡几秒
                this.stopContinue = 0;
            }
        }

        this.lastMonitor = core.getCurrentTime();
    }

    /**
     * 重新播放
     */
    replay() {
        this.playList = this.originList.slice();
        let src = this.playList.shift();
        let core = this.core;
        core.src(src);
        core.play();
    }

    /**
     * 播放
     */
    play() {
        let core = this.core;
        core.play();
    }

    /**
     * 暂停播放
     */
    pause() {
        let core = this.core;
        core.pause();
        this.trigger('pause');
        // vStat.sendVplayer('402000');
    }

    /**
     * 隐藏组件
     */
    hide() {
        let core = this.core;
        core.hide();
        this.control.hideAll();
    }

    /**
     * 显示组件
     */
    show() {
        let core = this.core;
        core.show();
        this.control.showAll();
    }

    /**
     * 暂停视频播放
     */
    stop() {
        let core = this.core;
        core.pause();
        this.control.setTime(0);
    }

    /**
     * 播放下一条视频
     *
     * @param {string} src
     */
    next(src) {
        let core = this.core;
        core.src(src);
        this.control.reset();
        this.playButton.changeState('pause');
    }

    /**
     * 得到当前播放时间
     *
     * @returns {number} 当前播放时间
     */
    getCurrentTime() {
        return this.currentTime;
    }

    /**
     * 销毁组件
     */
    destory() {
        let core = this.core;
        this.off();
        this.title.destory();
        this.control.destory();
        this.poster.destory();
        this.playButton.destory();
        this.error.destory();
        core.destory();
    }
    /**
     * 播放结束
     */
    ended(core, self, control) {

        core.el.currentTime = 0;

        /** 发送播放完毕统计 */
        self.vStat.sendVplayer('305000');

        let _sedataId = control.getInd();
        if (typeof window.sedata == 'undefined' || _sedataId < 0 || _sedataId > sedata.length) {
            self.recommend.initShow();
            core.hide();
            control.hide();
        } else {
            let { link } = window.sedata[_sedataId];
            window.location.href = link;
        }

    }
}

Events.mixTo(Video);
export default Video;



// WEBPACK FOOTER //
// ./components/f.component.video.pc/app/lib/recodeVideo.js